import { render, staticRenderFns } from "./VUnauthorized.vue?vue&type=template&id=3a62c991&"
import script from "./VUnauthorized.vue?vue&type=script&lang=ts&"
export * from "./VUnauthorized.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports